import { EventEmitter } from "lucidjs";

let instance = null;

export default class Hub {
	constructor() {
		if (null === instance) {
			instance = this;
			EventEmitter.call(this);
			Object.assign(this, EventEmitter.prototype)
		}

		return instance;
	}

	static getInstance() {
		if (null === instance) {
			instance = new Hub;
		}

		return instance;
	}
}